import getTimePeriods from '@pancakeswap/utils/getTimePeriods'
import { useTranslation } from '@pancakeswap/localization'

const WithdrawalFeeTimer: React.FC<React.PropsWithChildren<{ secondsRemaining: number }>> = ({ secondsRemaining }) => {
  const { t } = useTranslation()
  const { days, hours, minutes } = getTimePeriods(secondsRemaining)

  return (
    <span>
      {t('%day%d %hour%h:%minute%m', { day: days, hour: hours, minute: minutes })}
    </span>
  )
}

export default WithdrawalFeeTimer
